module.exports = {"serverUrl":"https://app-api.artsozaii.com/admin"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 125
// module chunks = 98